<template>
    <header class="bg-light">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-2">
                    <router-link :to="{name: 'homepage'}" class="align-middle">
                        <img src="../media/logo_crop.png" alt="UNTRR" height="50px">
                    </router-link>
                </div>
                <div class="col-8 text-center">
                    <div class="menu">
                        <router-link :to="{name: 'vignette'}">
                            <b>{{ $tc('vignetteWord', 1) }}</b>
                        </router-link>
                        <router-link :to="{name: 'toll'}">
                            <b>{{ $tc('tollWord', 0) }}</b>
                        </router-link>
                    </div>
                </div>
                <div class="col-2 text-right">
                    <div class="nav-icons right-menu">
                        <Language></Language>
                        <div class="user">
                            <div @click.stop="toggleDropdownMenu('useraccount')"
                                class="user-icon pointer"
                                :class="{'active': userMenuState}">
                                <span class="icon person-icon"></span>
                            </div>
                            <ul class="user-menu" v-if="userMenuState" @mouseleave="closeDropdownMenu()" @click="closeDropdownMenu()">
                                <li><router-link :to="{name: 'account-data'}">{{ $t('account_container_my_account') }}</router-link></li>
                                <li><router-link :to="{name: 'my-cars'}">{{ $t('account_container_vehicles') }}</router-link></li>
                                <li><router-link :to="{name: 'my-orders'}">{{ $t('account_container_orders') }}</router-link></li>
                                <li><router-link :to="{name: 'profiles'}">{{ $t('account_container_profiles') }}</router-link></li>
                                <li><router-link :to="{name: 'cards'}">{{ $t('account_container_cards') }}</router-link></li>
                                <li class="last"><a class="logout pointer" @click.prevent="doLogout()">{{ $t('btn_logout') }}</a></li>
                            </ul>
                        </div>
                        <router-link class="d-flex" :to="{name: 'cart'}">
                            <div class="shopping-cart">
                                <div class="badge-count" v-if="cartCount > 0">
                                    {{cartCount}}
                                </div>
                                <div class="icon cart-icon"></div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import Language from './snippets/Language.vue';
    import { mapGetters, mapActions } from 'vuex';
    import headerMixin from './mixins/header.js';

    export default {
        name: 'HeaderDesktop',
        mixins: [
            headerMixin
        ],
        components: {
            Language
        },
        computed: {
            ...mapGetters('cart', [
                'cartCount'
            ]),
            userMenuState: function () {
                if(this.openedDropdown == 'useraccount') {
                    return true;
                } else {
                    return false;
                }
            }
        },
        props: {
        },
        methods: {
            ...mapActions({
                logout: 'auth/doLogout',
            }),
            doLogout() {
                this.logout();
                this.$router.push({ name: 'login' });
                //close user account dropdown from header after logout
                this.mutateCloseDropdown();
            },
        },
    }
</script>

<style scoped lang="scss">

    $lightgrey: lightgrey;
    $white-yellow: #FAF9F6;
    $green: #59af54;
    $black: #000;
    $accent-color: #3F24E2;
    $black: #000;

    header {
        padding: 20px 0;
        color: $black;
        display: flex;
        align-items: center;
        z-index:1040;
        position: fixed;
        width: 100%;

        a {
            color: $black;
        }

        &.no-border {
            border-bottom: none;
        }
    }

    /* visited link */

    a {

        text-decoration: none;
        color: $black;
    }

    .icon {
        background-size: contain;
        background-repeat: no-repeat;
        width: 20px;
        height: 20px;
        margin: 0 auto;
        background-position: center;
    }

    .home-title {
        padding: 5px;

        img {
            max-height: 45px;
        }
    }
    .menu {
        a {
            display: inline-block;
            margin: 0 40px;
            padding: 5px 10px;
            border-radius: 5px;
            text-transform: uppercase;

            &:hover {
                color: $accent-color;
            }

            &:active, &.router-link-exact-active {
                color: $accent-color;
                background: transparent;
            }
        }

        .dropdown {

            position: relative;
            display: inline-block;

            .dropdown-menu {

                font-size: 100%;
                padding: 5px 5px 0 5px;
                border: none;
                background: #272D37;
                top: 40px !important;
                left: auto;
                transform: none !important;
                width: 300px !important;

                a {
                    margin: 0 0 5px 0;
                }
            }
        }
    }

    .fa-sort-down {
        vertical-align: top;
    }

    .fa-shopping-cart:before {
        font-size: 24px;
        padding: 5px;
    }

    .fa-user-circle:before {
        font-size: 24px;
        padding: 5px;
    }

    .cart-icon {

        position: relative;

        .badge-count {
            position: absolute;
            background: #F23E5C;
            color: white;
            border-radius: 50%;
            font-size: 11px;
            right: -3px;
            top: -7px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 1;
            padding: 7px;
            width: 15px;
            height: 15px;
        }
    }

    .right-menu {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .user {
        position: relative;
        margin-right: 18px;

        .user-icon {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;

            &.active, &:hover {
                background: #EEEDEC;
                border-radius: 50%;
            }
        }

        span {
            display: block;
        }

        .user-menu {
            position: absolute;
            width: 193px;
            right: calc(100% - 50px);
            text-align: left;
            border: 1px solid #0F2443;
            background: #FAF9F6;
            border-radius: 3px;
            top: 50px;
            padding: 9.5px 0px;
            margin-top: 8px;

            &:after, &:before {
                bottom: 100%;
                left: 85%;
                border: solid transparent;
                content: "";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
            }

            &:after {
                border-color: rgba(250, 249, 246, 0);
                border-bottom-color: #FAF9F6;
                border-width: 7px;
                margin-left: -7px;
            }

            &:before {
                border-color: rgba(15, 36, 67, 0);
                border-bottom-color: #0F2443;
                border-width: 8px;
                margin-left: -8px;
            }

            li {

                &.last {
                    border-top: 1px solid #C7C7C6;
                    padding: 9.5px 0px 0px;
                    margin: 9.5px 0px 0px;
                }

                a {
                    padding: 9.5px 12px;
                    display: block;
                    font-size: 14px;

                    &:hover {
                        background: #EEEDEC;
                    }

                }
            }
        }
    }
</style>
